<template>
  <layout :title="$t('form.title')" double-content>
    <div slot="layout-content">
      <b-container>
        <form
          v-loading="`<i class='ti ti-refresh ti-spin'></i>`"
          @submit.prevent="submitEditForm"
        >
          <vue-form-generator
            :schema="filteredEditForm"
            :model="editFormModel"
            :options="{
              validationAfterLoad: true,
              validationAfterChanged: true,
            }"
            tag="div"
          />
          <b-button
            v-if="editForm.fields.length > 0"
            type="submit"
            variant="primary"
            class="btn-fixed-bottom"
            block
            >{{ $t("actions.save") }}</b-button
          >

        </form>
        <br />
        <br />
        <h6 class="text-secondary">{{ $t("form.informations") }}</h6>
        <change-password
          :model-password="changePasswordFormModel"
          with-optional-fields
        />
      </b-container>
    </div>
    <template slot="layout-content-2">
      <b-container>
        <rgpd-card />
      </b-container>
    </template>
  </layout>
</template>

<script>
import Layout from "@/views/Layout";
import VueFormGenerator from "@triotech/vue-core/src/vendor/vue-form-generator";
import ChangePassword from "@/components/change-password";
import RgpdCard from "@/components/rgpd-card";

export default {
  name: "AccountView",
  components: {
    Layout,
    ChangePassword,
    RgpdCard,
    "vue-form-generator": VueFormGenerator.component,
  },
  data() {
    const user = this.user();

    return {
      editFormModel: {
        first_name: user.first_name,
        last_name: user.last_name,
        birth_name: user.birth_name,
        birth_date: this._.get(user, "birth_date.date"),
        gender: this.$t(user.gender),
        preferred_locale: user.preferred_locale,
        //rajout input
        job: this.$t(user.job),
        studyLevel: this.$t(user.studyLevel),
        birthPlace: this.$t(user.birthPlace),
        address: this.$t(user.address),
        postalCode: this.$t(user.postalCode),
        city: this.$t(user.city),
        telephone: this.$t(user.telephone),
      },
      editForm: {
        fields: [
          {
            // NAMES

            type: "input",
            disabled: this.$helper.isLegacy,
            id: "first_name",
            inputType: "text",
            label: this.$t("form.first_name"),
            maxlength: null,
            model: "first_name",
            placeholder: this.$t("form.first_name"),
            // readonly: this.$helper.isLegacy,
            // required: true,
          },
          {
            type: "input",
            disabled: this.$helper.isLegacy,
            id: "last_name",
            inputType: "text",
            label: this.$t("form.last_name"),
            maxlength: null,
            model: "last_name",
            placeholder: this.$t("form.last_name"),
            // readonly: this.$helper.isLegacy,
            // required: true,
          },
          {
            type: "input",
            disabled: this.$helper.isLegacy,
            id: "birth_name",
            inputType: "text",
            label: this.$t("form.birth_name"),
            maxlength: null,
            model: "birth_name",
            placeholder: this.$t("form.birth_name"),
            // readonly: this.$helper.isLegacy,
            // required: true,
          },

          // BIRTHDATE
          {
            type: "datePicker",
            // visible: isVisible,
            id: "birth_date",
            inputType: "date",
            label: this.$t("form.birth_date"),
            maxlength: null,
            model: "birth_date",
            placeholder: this.$t("form.birth_date"),
            normal: true,
            required: true,
          },
          // BIRTH PLACE
          {
            type: "input",
            // disabled: this.$helper.isLegacy,
            id: "birthPlace",
            inputType: "text",
            label: this.$t("form.birthPlace"),
            maxlength: null,
            model: "birthPlace",
            placeholder: this.$t("form.birthPlace"),
            // readonly: this.$helper.isLegacy,
            required: true,
          },
          //GENDER
          {
            type: "vueMultiSelect",
            // disabled: this.$helper.isLegacy,
            id: "gender",
            label: this.$t("form.gender"),
            maxlength: null,
            model: "gender",
            placeholder: this.$t("form.gender"),
            // readonly: this.$helper.isLegacy,
            // required: true,
            values: this._.transform(
              this.get().enums.gender,
              (result, value, key) => {
                result.push(this.$t(key));
              },
              []
            ),
            selectOptions: {
              selectLabel: "",
              selectedLabel: "",
              deselectLabel: "",
              placeholder: "",
              noResult: this.$t("vms.no_result"),
              allowEmpty: false,
            },
          },
          {
            //LANGUAGE
            type: "vueMultiSelect",
            // disabled: false,
            id: "preferred_locale",
            label: this.$t("form.language"),
            maxlength: null,
            model: "preferred_locale",
            placeholder: this.$t("form.language"),
            readonly: false,
            // required: true,
            values: this._.transform(
              this.get().enums.language,
              (result, value, key) => {
                if (this.$helper.isLegacy) {
                  result.push(value.toUpperCase());
                } else {
                  result.push(key);
                }
              },
              []
            ),
            selectOptions: {
              selectLabel: "",
              selectedLabel: "",
              deselectLabel: "",
              placeholder: "",
              noResult: this.$t("vms.no_result"),
              allowEmpty: false,
            },
          },
          // TELEPHONE
          {
            type: "input",
            // disabled: this.$helper.isLegacy,
            id: "telephone",
            inputType: "telephone",
            label: this.$t("form.telephone"),
            maxlength: 15,
            model: "telephone",
            placeholder: this.$t("form.telephone"),
            // readonly: this.$helper.isLegacy,
            required: false,
          },
          // ADRESSE
          {
            type: "input",
            // disabled: this.$helper.isLegacy,
            id: "address",
            inputType: "text",
            label: this.$t("form.address"),
            maxlength: null,
            model: "address",
            placeholder: this.$t("form.address"),
            // readonly: this.$helper.isLegacy,
            required: false,
          },
          // POSTALCODE
          {
            type: "input",
            // disabled: this.$helper.isLegacy,
            id: "postalCode",
            inputType: "text",
            label: this.$t("form.postalCode"),
            maxlength: null,
            model: "postalCode",
            placeholder: this.$t("form.postalCode"),
            // readonly: this.$helper.isLegacy,
            required: false,
          },
          // CITY
          {
            type: "input",
            // disabled: this.$helper.isLegacy,
            id: "city",
            inputType: "text",
            label: this.$t("form.city"),
            maxlength: null,
            model: "city",
            placeholder: this.$t("form.city"),
            // readonly: this.$helper.isLegacy,
            required: false,
          },
          {
            //JOB
            type: "vueMultiSelect",
            // disabled: this.$helper.isLegacy,
            id: "job",
            label: this.$t("form.job"),
            maxlength: null,
            model: "job",
            placeholder: this.$t("form.job"),
            // readonly: this.$helper.isLegacy,
            required: false,
            values: this._.transform(
              this.get().enums.job,
              (result, value, key) => {
                result.push(this.$t(key));
              },
              []
            ),
            selectOptions: {
              selectLabel: "",
              selectedLabel: "",
              deselectLabel: "",
              placeholder: "",
              noResult: this.$t("vms.no_result"),
              allowEmpty: false,
            },
          },
          //STUDIES
          {
            type: "vueMultiSelect",
            // disabled: this.$helper.isLegacy,
            id: "studyLevel",
            label: this.$t("form.studyLevel"),
            maxlength: null,
            model: "studyLevel",
            placeholder: this.$t("form.studyLevel"),
            // readonly: this.$helper.isLegacy,
            required: false,
            values: this._.transform(
              this.get().enums.studies,
              (result, value, key) => {
                result.push(this.$t(key));
              },
              []
            ),
            selectOptions: {
              selectLabel: "",
              selectedLabel: "",
              deselectLabel: "",
              placeholder: "",
              noResult: this.$t("vms.no_result"),
              allowEmpty: false,
            },
          },
        ],
      },

      changePasswordFormModel: {
        password: "",
        password_confirm: "",
        old_password: "",
      },
    };
  },

  computed: {
    copyEditFormModel() {
      const obj = this._.cloneDeep(this.editFormModel);
      // inverser valeur
      const inverseAndTranslatedEnumGender = this.$helper.swapObjKeyValue(
        this.get().enums.gender,
        true
      );

      const inverseAndTranslatedEnumStudies = this.$helper.swapObjKeyValue(
        this.get().enums.studies,
        true
      );

      const inverseAndTranslatedEnumJob = this.$helper.swapObjKeyValue(
        this.get().enums.job,
        true
      );

      // set Enum value in model copy.
      obj.birth_date = this.$moment(obj.birth_date).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      obj.gender = inverseAndTranslatedEnumGender[obj.gender];
      obj.job = inverseAndTranslatedEnumJob[obj.job];
      obj.studyLevel = inverseAndTranslatedEnumStudies[obj.studyLevel];
      return obj;
    },
    filteredEditForm() {
      if (!this.$helper.canShowLanguage) {
        this.$delete(
          this.editForm.fields,
          this._.findIndex(this.editForm.fields, { id: "preferred_locale" })
        );
      }

      return this.editForm;
    },
  },
  mounted() {
    let test = this._.transform(
      this.get().enums.gender,
      (result, value, key) => {
        result.push(this.$t(key));
      },
      []
    );
    if (this.$helper.isLegacy) {
      this.changePasswordFormModel.email = this.user().email;
    } else {
      this.editFormModel.email = this.user().email;

      this.editForm.fields.push({
        type: "input",
        disabled: false,
        id: "email",
        inputType: "email",
        label: this.$t("form.email"),
        maxlength: null,
        model: "email",
        placeholder: this.$t("form.email"),
        readonly: false,
        required: true,
        //
      });
    }
  },
  methods: {
    submitEditForm() {
      return this.$ajax
        .patch("user/me/edit", this.copyEditFormModel)
        .then((data) => {
          if (data.status === "ok") {
            this.$helper.setLocale(this.copyEditFormModel.preferred_locale);
            this.$notify({
              title: this.$t("flashes.edit.title"),
              text: this.$t("flashes.edit.success"),
              type: "success",
            });
            this.updateUser();
          }
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            this.$notify({
              text: this.$t(`flashes.edit.${err.response.data.error}`),
              type: "error",
            });
          }
        });
    },
    async updateUser() {
      const { oauth } = this._.cloneDeep(this.get());
      oauth.user = await this.$ajax.get("user/me/");
      this.set({ oauth });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/scss/vars";

/deep/ .vue-form-generator {
  > div {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;

    .form-group {
      flex: 1;
      flex-basis: calc(50% - 20px);
      margin: 0 10px;

      .form-control,
      .multiselect {
        max-width: 70%;

        .multiselect__placeholder {
          color: $dark-grey;
        }

        &[readonly] {
          color: $dark-grey;
          background-color: $light-grey;
        }

        &.multiselect--disabled {
          background-color: $light-grey;
          opacity: 1;

          .multiselect__select,
          .multiselect__tags {
            background-color: $light-grey;
          }
        }
      }
    }
  }

  &.change-password-form {
    .form-group {
      flex-basis: calc(33% - 20px);

      .form-control {
        width: 80% !important;
        max-width: 80% !important;
      }
    }
  }
}

@include media-breakpoint-down(md) {
  /deep/ .vue-form-generator {
    > div {
      .form-group {
        flex-basis: 100%;

        .form-control,
        .multiselect {
          width: 100% !important;
          max-width: 100% !important;
        }
      }
    }

    &.change-password-form {
      .form-group {
        flex-basis: 100%;

        .form-control,
        .multiselect {
          width: 100% !important;
          max-width: 100% !important;
        }
      }
    }
  }
}
</style>
